import Axios from 'axios';
import {  isNullOrEmpty, startsWith, 
  normalizeUrl, umlaute, isImage }  from './Utils.js'

// return { albums: [], slides: [] } or { comment: '' }
export { getToc, getAlbum };

async function getToc(baseUrl, albumUrl) {
  var response = await Axios.get(baseUrl + "/toc.txt");
  var lines = response.data.split("\n");
  var section = "";
  var slides = [];
  var albums = [];
  for (var i = 0; i < lines.length; i++) {
    var line = lines[i];
    line = line.replace("{sv}", "http://www.seilverhau.de/alben/");
    line = line.replace("{ts}", "slideshow/");
    line = line.trim();
    if (isNullOrEmpty(line)) continue;
    var entries = line.split("=>");
    var obj = new Object();
    if (entries.length > 0) {
      var entry = entries[0].trim();
      obj["isSectionTitle"] = startsWith(entry, "#");
      obj["title"] = entry;
      if (obj["isSectionTitle"]) {
        section = entry.substr(1, entry.length).trim();
        obj["title"] = section;
      }
      if (
        !obj["isSectionTitle"] &&
        section == "slideshow" &&
        entries.length > 2
      ) {
        slides.push({
          srcAlbum: entries[1].trim(),
          src: entries[2].trim(),
          show: true
        });
      }
      if (entries.length > 1) {
        obj["url"] = entries[1].trim();
        if (albumUrl && section != "slideshow") {
          
          var k = normalizeUrl(albumUrl);
          var u = normalizeUrl(obj['url']);
          if (k == u) {
            return { title: obj['title'] }
          }
          
          if( startsWith(k, '/albums/') ) {
            var k2 = k.substr(7);
            if (k2 == u) {
              return { title: obj['title'] }
            }
          }
        }
      }
      obj["section"] = section;
    }
    if (section != "slideshow") {
      albums.push(obj);
    }
  }
  
  return albumUrl ? { title: 'Kein Titel gefunden.' } : 
      { albums: albums, slides: slides } 
}

// returns {items: items, title: title}
async function getAlbum(baseUrl, albumUrl, callback) {
  baseUrl = normalizeUrl(baseUrl);
  albumUrl = normalizeUrl(albumUrl);

  const absUrl = baseUrl + albumUrl;
  var response = await Axios.get(absUrl + "/config.txt");

  var toc = await getToc(baseUrl, albumUrl);
  var title = toc.title;

  var imgs = getImages(response, absUrl);
  // var items = [];
  // var itemsTemp = [];
  
  /* */
  callback(title, null, null, imgs)
  var b = 'a'
  if('a' == b) return;
  

  /*
  imgs.forEach(function (p) {
    console.log(p.idx + ": " + p.src + " " + p.w + "x" + p.h);
  });
  */

  for (var i = 0; i < imgs.length; i++) {
    var img = imgs[i];
    var counter = 0;
    img.onload = function () {
      var item = {
        src: this.src,
        w: this.width,
        h: this.height,
        thumbnail: this.thumbnail,
        title: this.title,
        idx: this.idx,
      };
      // itemsTemp.push(item);
      counter = counter +1;
      callback( title, item );

      if (counter == imgs.length) {
        callback( title, null, 'sort' );
        /*
        console.log("BEFORE ... ");
        itemsTemp.forEach(function (p) {
          console.log(p.idx + ": " + p.src);
        });
        
        itemsTemp.sort(function (p1, p2) {
          return p1.idx > p2.idx ? 1 : -1;
        });
        items = itemsTemp; // .reverse();
        
        console.log("AFTER ... ");
        itemsTemp.forEach(function (p) {
          console.log(p.idx + ": " + p.src + " " + p.w + "x" + p.h);
        });
        */
       
      }
    };
  }
}


function getImages(response, absUrl) {
  var lines = response.data.split("\n");
  var imgs = [];
  var counter = 0;
  for (var i = 0; i < lines.length; i++) {
    var line = lines[i];
    line = line.trim();
    if (isNullOrEmpty(line)) continue;
    var parts = line.split("=");
    if (parts.length > 1) {
      var imagename = parts[0].trim();
      var comment = parts[1].trim();
      if (isImage(imagename)) {
        var slideUrl = absUrl + "/slides/" + imagename;
        var thumbUrl = absUrl + "/thumbs/" + imagename;
        var img = new Image();
        img.src = slideUrl;
        img.thumbnail = thumbUrl;
        img.title = umlaute(comment);
        img.idx = counter;
        img.w = -1;
        img.h = -1;
        imgs.push(img);
        counter = counter + 1;
      }
    }
  }
  return imgs;
}